import { useMutation } from "@shared/lib/hooks";

import { ReportService } from "../services/Report.servie";
import { ToastService } from "@shared/lib/services";
import { REPORTS_LIST_QUERY_KEY } from "../constants";

export function useDeleteMedia(reportId: string, handleSuccess?: () => void) {
  const {
    mutate: deleteMedia,
    isLoading: isAdding,
    isSuccess: isAdded,
    variables,
  } = useMutation({
    mutationFn: async ({ mediaId }: { mediaId: string }) => {
      return await ReportService.deleteMediaReport({ mediaId }).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      );
    },
    options: {
      queryKey: [REPORTS_LIST_QUERY_KEY, reportId],
      skipInvalidation: false,
    },
    onSuccess: (c, _) => {
      handleSuccess?.();
      c.invalidateQueries({ queryKey: [REPORTS_LIST_QUERY_KEY] });
      // c.invalidateQueries({ queryKey: [REPORTS_LIST_QUERY_KEY, reportId] });
    },
  });
  return {
    deleteMedia,
    isAdding,
    isAdded,
    variables,
  };
}
